import { OpenUrlEnum } from '@/types/url-enum'
import { isInAppUA, isIOSAppUA } from '@/utils/uaConfig'
import { openWindow } from '../url'
import { dataURLtoBlob, imgUrlToBase64 } from './base64Conver'
import UaParser from 'ua-parser-js'
import { isIpad } from '../is'

export type StatusResponse = 'start' | 'success' | 'error'
/**
 * Download online pictures
 * @param url
 * @param filename
 * @param mime
 * @param bom
 */
export function downloadByOnlineUrl(url: string, filename: string, mime?: string, bom?: BlobPart) {
  imgUrlToBase64(url).then((base64) => {
    downloadByBase64(base64, filename, mime, bom)
  })
}

/**
 * Download pictures based on base64
 * @param buf
 * @param filename
 * @param mime
 * @param bom
 */
export function downloadByBase64(buf: string, filename: string, mime?: string, bom?: BlobPart) {
  const base64Buf = dataURLtoBlob(buf)
  downloadByData(base64Buf, filename, mime, bom)
}

/**
 * Download according to the background interface file stream
 * @param {*} data
 * @param {*} filename
 * @param {*} mime
 * @param {*} bom
 */
export function downloadByData(data: BlobPart, filename: string, mime?: string, bom?: BlobPart) {
  const blobData = typeof bom !== 'undefined' ? [bom, data] : [data]
  const blob = new Blob(blobData, { type: mime || 'application/octet-stream' })

  const blobURL = window.URL.createObjectURL(blob)
  const tempLink = document.createElement('a')
  tempLink.style.display = 'none'
  tempLink.href = blobURL
  tempLink.setAttribute('download', filename)
  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank')
  }
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
  window.URL.revokeObjectURL(blobURL)
}

/**
 * Download file according to file address
 * @param {*} sUrl
 */
export function downloadByUrl({
  url,
  target = '_blank',
  fileName
}: {
  url: string
  target?: TargetContext
  fileName?: string
}): boolean {
  const isChrome = window.navigator.userAgent.toLowerCase().indexOf('chrome') > -1
  const isSafari = window.navigator.userAgent.toLowerCase().indexOf('safari') > -1

  if (/(iP)/g.test(window.navigator.userAgent)) {
    console.error('Your browser does not support download!')
    return false
  }
  if (isChrome || isSafari) {
    const link = document.createElement('a')
    link.href = url
    link.target = target

    if (link.download !== undefined) {
      link.download = fileName || url.substring(url.lastIndexOf('/') + 1, url.length)
    }

    if (document.createEvent) {
      const e = document.createEvent('MouseEvents')
      e.initEvent('click', true, true)
      link.dispatchEvent(e)
      return true
    }
  }
  if (url.indexOf('?') === -1) {
    url += '?download'
  }

  openWindow(url, { target })
  return true
}

/**
 * 模拟a标签下载文件
 * @param url
 * @param fileName
 */
export function downloadFile(url: string, fileName?: string) {
  url = url + '?t=' + new Date().getTime()
  const image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = () => {
    const canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    const context = canvas.getContext('2d') as CanvasRenderingContext2D
    context.drawImage(image, 0, 0, image.width, image.height)
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob as Blob)
      const a = document.createElement('a')
      a.download = fileName || url.substring(url.lastIndexOf('/') + 1, url.length)
      a.href = url
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
    })
  }
  console.log(url)
  image.src = url
}

export const handleDownLoadWeelife3d = () => {
  const uaParser = new UaParser()
  const uaInfo = uaParser.getResult()
  if (
    uaInfo.browser.name === 'WeChat' ||
    uaInfo.browser.name === 'Weibo'
  ) {
    return
  }
  const isAPP = isInAppUA(uaInfo.ua)
  const isIOSApp = isIOSAppUA(uaInfo.ua)
  if (uaInfo.os.name === 'Android') {
    openWindow(OpenUrlEnum.GOOGLE_PLAY, { target: isAPP ? '_self' : '_blank' })
  } else if (uaInfo.os.name === 'iOS' || isIpad() || isIOSApp || (uaInfo.os.name as string).indexOf('Mac') > -1) {
    openWindow(OpenUrlEnum.IOS_APP_STORE, { target: isAPP ? '_self' : '_blank' })
  } else {
    openWindow(OpenUrlEnum.GOOGLE_PLAY, { target: isAPP ? '_self' : '_blank' })
  }
}
